import React, { useState, useEffect, useCallback } from 'react';
import Modal from "react-bootstrap/Modal";
import { pushNotification } from "utils/notifications";
import ConfigPhiKhacApi from "service/QuanTriHeThong/CauHinhTinhLaiVaHeThong/ConfigPhiKhacApi";
import ConfigPhiKhacHangKyApi from "service/QuanTriHeThong/CauHinhTinhLaiVaHeThong/ConfigPhiKhacHangKyApi";
import { TablePhiKhac } from './TablePhiKhac.js';
import { ModalThemMoi } from "./ThemMoi/ModalThemMoi";
import { ModalXoa } from "./Xoa/ModalXoa";
import { ModalSuDung } from "./Sudung/ModalSuDung";
export const QuanLyPhiKhacModal = ({ show, onHide, isPeriodic, loanType, title, CustomCheckbox }) => {
    const [listData, setListData] = useState({ List: [], iTotal: 0 });
    const [loading, setLoading] = useState(true);
    const [hideParent, setHideParent] = useState(false);
    const [showModalThem, setShowModalThem] = useState(false);
    const [modalThemData, setModalThemData] = useState(null);
    const [showModalXoa, setShowModalXoa] = useState(false);
    const [modalXoaData, setModalXoaData] = useState(null);
    const [showModalSuDung, setShowModalSuDung] = useState(false);
    const [modalSuDungData, setModalSuDungData] = useState(null);
    const api = isPeriodic ? ConfigPhiKhacHangKyApi : ConfigPhiKhacApi;
    const getLogoSrc = (type) => {
        switch (type) {
            case 1:
                return "/app-assets/images/logo-tin-chap-v2.png";
            case 2:
                return "/app-assets/images/icon-tra-gop-v3.png";
            case 3:
                return "/app-assets/images/icon-cam-do-v2.png";
            default:
                return "/app-assets/images/logo-tin-chap-v2.png";
        }
    };

    const fetchFees = useCallback(() => {
        setLoading(true);
        api.getList(loanType)
            .then(res => {
                if (res.status === 200) {
                    setListData(res.data || { List: [], iTotal: 0 });
                }
            })
            .catch(() => pushNotification("Lấy danh sách phí thất bại!", "error"))
            .finally(() => setLoading(false));
    }, [api, loanType]);

    useEffect(() => {
        if (show) {
            fetchFees();
        }
    }, [show, fetchFees]);

    const handleOpenModalThem = (item) => {
        setModalThemData(item);
        setShowModalThem(true);
        setHideParent(true);
    };
    const handleCloseModalThem = () => {
        setShowModalThem(false);
        setHideParent(false);
    };
    const handleOpenModalXoa = (item) => {
        setModalXoaData(item);
        setShowModalXoa(true);
        setHideParent(true);
    };
    const handleCloseModalXoa = () => {
        setShowModalXoa(false);
        setHideParent(false);
    };
    const handleOpenModalSuDung = (item) => {
        setModalSuDungData(item);
        setShowModalSuDung(true);
        setHideParent(true);
    };
    const handleCloseModalSuDung = () => {
        setShowModalSuDung(false);
        setHideParent(false);
    };
    const handleSavedModalThem = () => {
        handleCloseModalThem();
        fetchFees();
    };
    const handleSavedModalXoa = () => {
        handleCloseModalXoa();
        fetchFees();
    };
    const handleSavedModalSuDung = () => {
        handleCloseModalSuDung();
        fetchFees();
    };
    return (
        <>
            <Modal show={show && !hideParent} onHide={onHide} size="lg" centered className="modal-new modal fade text-left">
                <div className="modal-content">
                    <Modal.Header>
                        <div style={{ display: 'flex', alignItems: 'center', marginLeft: 15, marginTop: 15 }}>
                            <img
                                src={getLogoSrc(loanType)}
                                alt="Logo"
                                style={{
                                    width: '28px',
                                    height: '28px',
                                    marginRight: '10px'
                                }}
                            />
                            <h4 className="modal-title color7-bold" style={{ margin: 0 }}>
                                {title}
                            </h4>
                        </div>
                        <button type="button" className="close-popup-new" onClick={onHide}>
                            <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <TablePhiKhac
                            isLoading={loading}
                            listDanhSach={listData}
                            onReload={fetchFees}
                            loanType={loanType}
                            isPeriodic={isPeriodic}
                            CustomCheckbox={CustomCheckbox}
                            onEdit={handleOpenModalThem}
                            onDelete={handleOpenModalXoa}
                            onUse={handleOpenModalSuDung}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="button"
                            className="btn btn-new-main btn-closenew"
                            onClick={onHide}
                        >
                            <span>
                                <i className="mdi mdi-close"></i>
                            </span>
                            &nbsp; Đóng
                        </button>
                    </Modal.Footer>
                </div>
            </Modal>
            {showModalThem && (
                <ModalThemMoi
                    show={showModalThem}
                    onHide={handleCloseModalThem}
                    onSaved={handleSavedModalThem}
                    item={modalThemData}
                    loanType={loanType}
                    isPeriodic={isPeriodic}
                    CustomCheckbox={CustomCheckbox}
                />
            )}
            {showModalXoa && modalXoaData && (
                <ModalXoa
                    show={showModalXoa}
                    onHide={handleCloseModalXoa}
                    onDeleted={handleSavedModalXoa}
                    item={modalXoaData}
                    isPeriodic={isPeriodic}
                />
            )}
            {showModalSuDung && modalSuDungData && (
                <ModalSuDung
                    show={showModalSuDung}
                    onHide={handleCloseModalSuDung}
                    onChanged={handleSavedModalSuDung}
                    item={modalSuDungData}
                    isPeriodic={isPeriodic}
                />
            )}
        </>
    );
};